const ReCaptchaAlertBarErrorMessage: string =
  "Please verify that you are not a robot.";
export default ReCaptchaAlertBarErrorMessage;
